import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "utils/base-query";

export const analyticsApi = createApi({
  reducerPath: "analyticsApi",
  tagTypes: ["Analytics"],

  baseQuery: baseQuery,

  endpoints: (builder) => ({
    getCampaignsAnalytics: builder.query({
      query: () => ({
        url: "/admin/analytics/get-all-campaigns",
        method: "GET",
      }),
      providesTags: ["Analytics"],
    }),
    getUsersCampaignsAnalytics: builder.query({
      query: ({ startDate, endDate, page = 1, limit = 10 }) => ({
        url: "/admin/analytics/users/campaigns",
        method: "GET",
        params: {
          startDate,
          endDate,
          page,
          limit,
        },
      }),
      providesTags: ["Analytics"],
    }),
    getLeadsAnalytics: builder.query({
      query: () => ({
        url: "/admin/analytics/get-all-leads",
        method: "GET",
      }),
      providesTags: ["Analytics"],
    }),
    getUsersLeadsAnalytics: builder.query({
      query: ({ startDate, endDate, page = 1, limit = 10 }) => ({
        url: "/admin/analytics/users/leads",
        method: "GET",
        params: {
          startDate,
          endDate,
          page,
          limit,
        },
      }),
      providesTags: ["Analytics"],
    }),
  }),
});

export const {
  useGetCampaignsAnalyticsQuery,
  useGetUsersCampaignsAnalyticsQuery,
  useGetLeadsAnalyticsQuery,
  useGetUsersLeadsAnalyticsQuery,
} = analyticsApi;
